import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Offer } from '../../interfaces/offers.interface';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-offer-image',
  standalone: false,
  templateUrl: './offer-image.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./offer-image.component.scss']
})
export class OfferImageComponent {
  imagesUrl = `${environment.ImagesUrl}/offer/`;
  partnerImagesUrl = `${environment.ImagesUrl}/partners/`;
  @Input() offer?: Offer;
  @Input() showFullImage: boolean = false; // Toggle between thumb and full image
  @Input() imageClass: string = ''; // Additional CSS classes for the image

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  
  ) {}

  goToPartner(offer: Offer): void {
    if (offer.partner_id) {
      this.router.navigate(['/partner', offer.partner_id]);
    }
  }
}